export default __webpack_public_path__ + "static/media/orange-logo.44e8bd6f.svg";